import BaseComponent from '@/components/base';

export default class Modal extends BaseComponent {
  xButton = `
<div class="x-button">
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
<path d="M13 1L1 13" stroke="#4C5151" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13 13L1 1" stroke="#4C5151" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</div>
  `;
  modalStyle() {
    return `
  <style>
    .x-button {
      cursor: pointer;
      margin-right: 20px;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
      user-select: none;
      -webkit-user-select: none;
      touch-action: manipulation;
      position: relative;
      z-index: 10;
    }
    
    .x-button svg {
      pointer-events: none;
    }

    .modal-container {
      ${this.enabled ? 'display: flex;' : 'display: none;'}
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      justify-content: center;
      align-items: center;
      z-index: 100;
    }

    .modal-content {
    padding: 20px;
      width: ${this.modalWidth};
      height: ${this.modalHeight};
      ${
        this.transparentEnabled
          ? ''
          : `
         background-color: white;
        border-radius: 5px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);`
      };
    }

    .modal-header {
        display: flex;
        justify-content: end;
        position: relative;
        z-index: 10;
    }

    .modal-container--light {
      background-color: rgba(0, 0, 0, 0.2);
    }

    @media screen and (max-width: 1024px) {
      .modal-content {
        width: 100%;
        margin: 10px;
      }
    }

    </style>
  `;
  }
  render() {
    return `
    ${this.modalStyle()}
    <div class="modal-container ${
      this.getAttribute('light-bg') ? 'modal-container--light' : ''
    }">

        <div class="modal-content">
        ${
          !this.headerDisabled
            ? `<div class="modal-header">
            ${this.renderHeader()}
        </div>`
            : ''
        }

            ${this.renderBody()}
            <slot></slot>
        </div>
    </div>
    `;
  }

  renderHeader() {
    return `${this.xButton}`;
  }

  renderBody() {
    return ``;
  }

  get enabled() {
    return this.getAttribute('enabled') === 'true';
  }
  set enabled(value) {
    this.setAttribute('enabled', `${value}`);

    this.shadowRoot.querySelector('.modal-container').style.display = value
      ? 'flex'
      : 'none';

    if (this.onChangeEnabled) {
      this.onChangeEnabled(value);
    }
  }

  get modalWidth() {
    return this.getAttribute('modal-width') ?? 'auto';
  }

  get modalHeight() {
    return this.getAttribute('modal-height') ?? 'auto';
  }

  afterMount() {
    const xButton = this.shadowRoot.querySelector('.x-button');

    if (xButton) {
      // Handle both click and touch events for better iOS compatibility
      const closeModal = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.enabled = false;
      };

      xButton.addEventListener('click', closeModal);
      xButton.addEventListener('touchend', closeModal);
    }
  }

  get headerDisabled() {
    return this.getAttribute('header-disabled') === 'true';
  }

  get transparentEnabled() {
    return this.getAttribute('transparent') === 'true';
  }
}
